var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"homebottom"},[_c('div',{attrs:{"align":"center"}},[_vm._v(" Copyright © 1998-"+_vm._s(_vm.newYear)+" DRCnet. All Rights Reserved版权所有 国研网 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }